module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.missionSlotTemplateDetails.slotGroups), function(missionSlotGroup, index) {
    return _c('mission-slot-template-slotlist-group', {
      key: missionSlotGroup.uid,
      attrs: {
        "index": index,
        "missionSlotGroupCount": _vm.missionSlotTemplateDetails.slotGroups.length,
        "missionSlotGroup": missionSlotGroup
      }
    })
  }), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateSlotGroupCreateModal",
      modifiers: {
        "missionSlotTemplateSlotGroupCreateModal": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slotGroup')) + "\n    ")]), _vm._v(" "), (_vm.missionSlotTemplateUnsavedChanges) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-floppy-o",
      "yes-class": "btn btn-success",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slotTemplate.confirm.save.slotlist'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.saveMissionSlotTemplateSlotlist
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.save.mission.slotTemplate.slotlist')) + "\n      ")])], 1) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ae4cebc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlist.vue
// module id = 544
// module chunks = 0